// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"u2-z","subtitle":"v2-z","wrapper":"w2-z","leftArrow":"x2-z","rightArrow":"y2-z"};